import { render, staticRenderFns } from "./DocumentVersion.vue?vue&type=template&id=0de08610&"
import script from "./DocumentVersion.vue?vue&type=script&lang=js&"
export * from "./DocumentVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports